'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.friendlyUrl = friendlyUrl;

exports.default = function (name, params) {
    var urlFactory = linksoft.url[name];
    if (urlFactory) {
        return urlFactory(params || {});
    }
    return '#';
};

exports.initUrls = initUrls;

var _kebabCase = require('lodash/kebabCase');

var _kebabCase2 = _interopRequireDefault(_kebabCase);

var _deburr = require('lodash/deburr');

var _deburr2 = _interopRequireDefault(_deburr);

var _forOwn = require('lodash/forOwn');

var _forOwn2 = _interopRequireDefault(_forOwn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function friendlyUrl(url, name) {
    return url.replace(/\/$/, "") + "/" + (0, _kebabCase2.default)((0, _deburr2.default)(name));
}

/**
 * Usage:
 * import urls from './urls';
 * let url = urls('cart');
 * url = urls('productDetail', {id: 5, name: 'asdf'});
 *
 * @param name
 * @param params
 * @returns {*}
 */
function initUrls(name) {
    var urls = linksoft.url;
    if (typeof name === 'string') {
        return enhance(urls[name]);
    } else {
        (0, _forOwn2.default)(urls, function (value, key) {
            urls[key] = enhance(value);
        });
    }
}

function enhance(targetUrl) {
    if (typeof targetUrl === 'function') {
        return function (obj) {
            var url = targetUrl(obj);
            if (typeof obj.name === 'string') {
                if (url.charAt(url.length - 1) !== '/') url += '/';
                url += (0, _kebabCase2.default)((0, _deburr2.default)(obj.name)) + '/';
            }
            return url;
        };
    }
    return fallback;
}

function fallback() {
    return '/';
}


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/urls.js
// module id = 588
// module chunks = 0